import React, { useState, useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom'
import "react-datepicker/dist/react-datepicker.css";
import { ContentHeader, Loader } from '@components';
import { Form } from 'react-bootstrap';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import moment from 'moment';
import { toast } from 'react-toastify';
import { getUserById, saveUserData, updateUserData, getUserRoles } from '../../services/users';


const AddUsers = () => {
  const [isLoading, setLoading] = useState(false);
  const [userRoles, setUserRoles] = useState(false);
  const [fillData, setFillData] = useState({
    name: '',
    email: '',
    role_id: '',
    sales_num: '',
    agent_id: '',
    as_400_id: '',
    windows_id: '',
    depot: ''
  });
  const navigate = useNavigate();
  const params = useParams();


  useEffect(() => {
    UserTypeDropdown();
    if (typeof params.id !== "undefined") {
      getUser(params.id);
    }
  }, [])

  const getUser = (id: any) => {
    setLoading(true);
    getUserById(id).then(function (res: any) {
      const resp = res.data;
      setLoading(false);
      if (res.status === 200 && resp.Acknowledge == 1) {
        let respData = resp.user;
        setFillData({
          name: respData.name,
          email: respData.email,
          role_id: respData.role_id,
          sales_num: respData.sales_num,
          agent_id: respData.agent_id,
          as_400_id: respData.as_400_id,
          windows_id: respData.windows_id,
          depot: respData.depot
        });
      }
    }).catch(err => {
      setLoading(false);
      toast.error(err.response.data.FullMessage !== 'undefied' ? err.response.data.FullMessage : 'Internal Server Error!');
      navigate("/users");
    });
  };


  const UserTypeDropdown = () => {
    setLoading(true);
    getUserRoles().then(function (res) {
      const resp = res.data;
      if (resp.Acknowledge == 1) {
        if (resp.records) {
          setUserRoles(resp.records);
        }
        setLoading(false);
      }
    }).catch(err => {
      setLoading(false);
      return false;
    });
  };

  const saveUser = (values: any) => {
    setLoading(true);
    saveUserData({
      "name": values.name,
      "email": values.email,
      "role_id": values.role_id,
      "password": values.password,
      "sales_num": values.sales_num,
      "agent_id": values.agent_id,
      "as_400_id": values.as_400_id,
      "windows_id": values.windows_id,
      "depot": values.depot
    }).then(function (res) {
      const resp = res.data;
      setLoading(false);
      if (resp.Acknowledge == 1) {
        toast.success('User Saved Successfully!');
        navigate("/users");
      } else {
        toast.error(resp.FullMessage !== 'undefined' ? resp.FullMessage : 'Validation error found!');
      }
    }).catch(err => {
      setLoading(false);
      toast.error('Internal Server Error!');
    });
  };

  const updateUser = (id: any, values: any) => {
    setLoading(true);
    updateUserData(id, {
      "name": values.name,
      "email": values.email,
      "role_id": values.role_id,
      "password": values.password,
      "sales_num": values.sales_num,
      "agent_id": values.agent_id,
      "as_400_id": values.as_400_id,
      "windows_id": values.windows_id,
      "depot": values.depot
    }).then(function (res) {
      const resp = res.data;
      setLoading(false);
      if (resp.Acknowledge == 1) {
        toast.success('User updated Successfully!');
        navigate("/users");
      } else {
        toast.error('Validation error found');
      }
    }).catch(err => {
      setLoading(false);
      toast.error('Internal Server Error!');
    });
  };

  let validationShape = {
    name: Yup.string().required('Required'),
    role_id: Yup.string().required('Required'),
    email: Yup.string().required('Required').email(),
    password: Yup.string()
      .min(5, 'Must be 5 characters or more')
      .max(30, 'Must be 30 characters or less'),
    passwordRetype: Yup.string()
      .min(5, 'Must be 5 characters or more')
      .max(30, 'Must be 30 characters or less')
      .when('password', {
        is: (val: string) => !!(val && val.length > 0),
        then: Yup.string().oneOf(
          [Yup.ref('password')],
          'Both password need to be the same'
        )
      })
  };

  const { handleChange, values, handleSubmit, touched, errors } = useFormik({
    initialValues: fillData,
    enableReinitialize: true,
    validationSchema: Yup.object(validationShape),
    onSubmit: (values) => {
      if (typeof params.id !== "undefined") {
        updateUser(params.id, values);
      } else {
        saveUser(values);
      }
    }
  });

  return (
    <>
      <ContentHeader title={`${typeof params.id !== 'undefined' ? 'Edit' : 'Add'} User`} />
      <section className="content">
        <div className="container-fluid">
          <div className="card">
            <div className="card-body">
              <form onSubmit={handleSubmit}>
                <div className='row'>

                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Name</label>
                      <Form.Control
                        id="name"
                        name="name"
                        type="text"
                        onChange={handleChange}
                        placeholder="Name"
                        value={values.name}
                        isValid={touched.name && !errors.name}
                        isInvalid={touched.name && !!errors.name}
                      />
                      {touched.name && errors.name ? (
                        <Form.Control.Feedback type="invalid">
                          {errors.name}
                        </Form.Control.Feedback>
                      ) : ''}
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Email</label>
                      <Form.Control
                        id="email"
                        name="email"
                        type="email"
                        onChange={handleChange}
                        placeholder="example@slomins.com"
                        value={values.email}
                        isValid={touched.email && !errors.email}
                        isInvalid={touched.email && !!errors.email}
                      />
                      {touched.email && errors.email ? (
                        <Form.Control.Feedback type="invalid">
                          {errors.email}
                        </Form.Control.Feedback>
                      ) : ''}
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group">
                      <label>User Type</label>
                      <Form.Control
                        as="select"
                        name="role_id"
                        type="text"
                        onChange={handleChange}
                        value={values.role_id}
                        isValid={touched.role_id && !errors.role_id}
                        isInvalid={touched.role_id && !!errors.role_id}
                      >
                        <option value="">Select User Type</option>
                        {userRoles.length > 0 && userRoles.map((row: any, podidx: number) => (
                          <option key={`userrole_${podidx}`} value={row.id}>{row.name}</option>
                        ))}
                      </Form.Control>

                      {touched.role_id && errors.role_id ? (
                        <Form.Control.Feedback type="invalid">
                          {errors.role_id}
                        </Form.Control.Feedback>
                      ) : ''}
                    </div>
                  </div>

                  <div className="form-group col-md-12">
                    <label>Reset your password (Leave blank password fields if you don't wants to reset
                      password)</label>
                  </div>
                  <div className="form-group col-md-6">
                    <label>Password</label>
                    <Form.Control
                      name="password"
                      type="password"
                      placeholder="Password"
                      onChange={handleChange}
                      value={values.password}
                      isValid={values.password && touched.password && !errors.password}
                      isInvalid={values.password && touched.password && !!errors.password}
                    />
                    {touched.password && errors.password ? (
                      <Form.Control.Feedback type="invalid">
                        {errors.password}
                      </Form.Control.Feedback>
                    ) : ''}
                  </div>
                  <div className="form-group col-md-6">
                    <label>Confirm Password</label>
                    <Form.Control
                      name="passwordRetype"
                      type="password"
                      placeholder="Confirm Password"
                      onChange={handleChange}
                      value={values.passwordRetype}
                      isValid={values.passwordRetype && touched.passwordRetype && !errors.passwordRetype}
                      isInvalid={values.passwordRetype && touched.passwordRetype && !!errors.passwordRetype}
                    />
                    {touched.passwordRetype && errors.passwordRetype ? (
                      <Form.Control.Feedback type="invalid">
                        {errors.passwordRetype}
                      </Form.Control.Feedback>
                    ) : ''}
                  </div>

                  <hr />
                  <br />
                  <div className="form-group col-md-12 mt-3">
                    <h4>Agent Details (optional)</h4>
                  </div>
                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Salesman Number</label>
                      <Form.Control
                        id="sales_num"
                        name="sales_num"
                        type="text"
                        onChange={handleChange}
                        placeholder=""
                        value={values.sales_num}
                        isValid={touched.sales_num && !errors.sales_num}
                        isInvalid={touched.sales_num && !!errors.sales_num}
                      />
                      {touched.sales_num && errors.sales_num ? (
                        <Form.Control.Feedback type="invalid">
                          {errors.sales_num}
                        </Form.Control.Feedback>
                      ) : ''}
                    </div>
                  </div>


                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Agent Id</label>
                      <Form.Control
                        id="agent_id"
                        name="agent_id"
                        type="text"
                        onChange={handleChange}
                        placeholder=""
                        value={values.agent_id}
                        isValid={touched.agent_id && !errors.agent_id}
                        isInvalid={touched.agent_id && !!errors.agent_id}
                      />
                      {touched.agent_id && errors.agent_id ? (
                        <Form.Control.Feedback type="invalid">
                          {errors.agent_id}
                        </Form.Control.Feedback>
                      ) : ''}
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Windows Id</label>
                      <Form.Control
                        id="windows_id"
                        name="windows_id"
                        type="text"
                        onChange={handleChange}
                        placeholder=""
                        value={values.windows_id}
                        isValid={touched.windows_id && !errors.windows_id}
                        isInvalid={touched.windows_id && !!errors.windows_id}
                      />
                      {touched.windows_id && errors.windows_id ? (
                        <Form.Control.Feedback type="invalid">
                          {errors.windows_id}
                        </Form.Control.Feedback>
                      ) : ''}
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group">
                      <label>AS400 Id</label>
                      <Form.Control
                        id="as_400_id"
                        name="as_400_id"
                        type="text"
                        onChange={handleChange}
                        placeholder=""
                        value={values.as_400_id}
                        isValid={touched.as_400_id && !errors.as_400_id}
                        isInvalid={touched.as_400_id && !!errors.as_400_id}
                      />
                      {touched.as_400_id && errors.as_400_id ? (
                        <Form.Control.Feedback type="invalid">
                          {errors.as_400_id}
                        </Form.Control.Feedback>
                      ) : ''}
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="form-group">
                      <label>Depot</label>
                      <Form.Control
                        id="depot"
                        name="depot"
                        type="text"
                        onChange={handleChange}
                        placeholder=""
                        value={values.depot}
                        isValid={touched.depot && !errors.depot}
                        isInvalid={touched.depot && !!errors.depot}
                      />
                      {touched.depot && errors.depot ? (
                        <Form.Control.Feedback type="invalid">
                          {errors.depot}
                        </Form.Control.Feedback>
                      ) : ''}
                    </div>
                  </div>


                  <div className="col-12">
                    <div className="form-group btn_wrap mt-4">
                      <button type="submit" className="btn btn-primary red_btn">{typeof params.id !== 'undefined' ? 'Update' : 'Add'} User</button>
                      <Link to="/users" className="btn btn-primary red_outline_btn">Cancel</Link>
                    </div>
                  </div>
                </div>
              </form>
            </div>
            <Loader isLoading={isLoading} />
          </div>
        </div>
      </section>
    </>
  )

};

export default AddUsers;